var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63003 13.6637C8.44428 13.868 8.45933 14.1842 8.66366 14.37C8.86799 14.5557 9.18422 14.5407 9.36997 14.3363L8.63003 13.6637ZM14 8.5L14.37 8.83634C14.5433 8.64563 14.5433 8.35437 14.37 8.16366L14 8.5ZM9.36997 2.66366C9.18422 2.45933 8.86799 2.44428 8.66366 2.63003C8.45933 2.81578 8.44428 3.13201 8.63003 3.33634L9.36997 2.66366ZM2 8C1.72386 8 1.5 8.22386 1.5 8.5C1.5 8.77614 1.72386 9 2 9V8ZM9.36997 14.3363L14.37 8.83634L13.63 8.16366L8.63003 13.6637L9.36997 14.3363ZM14.37 8.16366L9.36997 2.66366L8.63003 3.33634L13.63 8.83634L14.37 8.16366ZM14 8H2V9H14V8Z",
    fill: "#218BCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.f79ce627115e2a083466ba2d0f6379f6.svg";
export { ForwardRef as ReactComponent };